<template>
  <div>
    <div class="header">
      <img :src="data.header.left" alt="">
    </div>
    <h2>{{data.dictionary.imageResultsTitle}}</h2>
    <div class="images">
      <div class="image" v-for="image in sortedImages" :key="image.id">
          <img loading="lazy" :src="image.url" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'indicators',
  props: {
    images: {},
    data: {}
  },
  data() {
    return {
      sortedImages: Array
    }
  },
  watch: {
    images: {
      immediate: true, 
      handler (val, oldVal) {
        this.sortedImages = []
        for (var key of Object.keys(val)) {
          let n = val[key];
          n.id = key;
          this.sortedImages.push(n);
        }
        this.sortedImages.sort((a,b) => {
          return a.order-b.order;
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .header {
    img {
      
      width:calc(100% - 1rem);
      height:auto;
    } 
    @media (max-width:949px) {
      display:none;
    }
  }
  .image {
    position:relative;

    img {
      position:absolute;
      left:0;
      top:0;
      width: 100%;
      height:100%;
      object-fit:cover;
    }
    &:after {
      display:block;
      content:'';
      padding-bottom:100%;
    }
  }
  .images {
      display: grid;
      grid-gap:0.1rem;
      grid-template-columns: repeat(auto-fill, minmax(3rem, 4rem));
  }
</style>
